import { createReducer, Action, on } from '@ngrx/store';

import { DatapointFieldActions } from './datapoint-field.actions';
import { DatapointFieldState } from './datapoint-field.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: DatapointFieldState = {
  loading: null,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      DatapointFieldActions.LoadDatapointField,
      (state): DatapointFieldState => ({
        ...state,
        loading: true,
        error: undefined,
        datapointField: undefined,
      })
    ),
    on(
      DatapointFieldActions.CreateDatapointField,
      DatapointFieldActions.UpdateDatapointField,
      (state): DatapointFieldState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      DatapointFieldActions.CreateDatapointFieldSuccess,
      DatapointFieldActions.UpdateDatapointFieldSuccess,
      DatapointFieldActions.LoadDatapointFieldSuccess,
      (state, action): DatapointFieldState => ({
        ...state,
        loading: false,
        datapointField: action.field,
      })
    ),
    on(
      DatapointFieldActions.CreateDatapointFieldFail,
      DatapointFieldActions.UpdateDatapointFieldFail,
      DatapointFieldActions.LoadDatapointFieldFail,
      (state, action): DatapointFieldState => ({ ...state, loading: false, error: action.error })
    )
  )
);

export function reducer(state: DatapointFieldState | undefined, action: Action) {
  return featureReducer(state, action);
}
